import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CheckoutList } from "@/modules/shop/components/CheckoutList";
import { Tag, Typography } from "@bookips/sds";
import { DropDownBox } from "../DropDownBox";
import useGetPackageQuery from "../queries/useGetPackageQuery";
// handout 자료 주문의 경우 separate 주문 처리
const SeparateOrderSection = (param)=>{
    let { orderItems , dropDown , appliedMaxCoupon , applyCoupon , userCoupons , hasCoupon , checkAvailableCouponList , handleDropDown , dropDownMode =true , isUpgrade  } = param;
    var _orderItems_;
    const packageId = isUpgrade ? orderItems === null || orderItems === void 0 ? void 0 : (_orderItems_ = orderItems[0]) === null || _orderItems_ === void 0 ? void 0 : _orderItems_.packageId : undefined;
    const { data: packageData  } = useGetPackageQuery(packageId);
    return /*#__PURE__*/ _jsx(DropDownBox, {
        headTitle: /*#__PURE__*/ _jsxs(Typography, {
            variant: "h6",
            className: "flex items-center gap-2",
            children: [
                "주문상품",
                /*#__PURE__*/ _jsxs("span", {
                    className: "text-secondary-main text-xl",
                    children: [
                        orderItems === null || orderItems === void 0 ? void 0 : orderItems.length,
                        "개"
                    ]
                })
            ]
        }),
        bodyElement: /*#__PURE__*/ _jsxs("div", {
            className: "flex flex-col gap-5",
            children: [
                /*#__PURE__*/ _jsx(CheckoutList, {
                    applyCoupon: applyCoupon,
                    dataSource: orderItems || [],
                    userCoupons: userCoupons,
                    hasCoupon: hasCoupon,
                    checkAvailableCouponList: checkAvailableCouponList,
                    appliedMaxCoupon: appliedMaxCoupon,
                    isUpgrade: isUpgrade
                }),
                (packageData === null || packageData === void 0 ? void 0 : packageData.description) && /*#__PURE__*/ _jsx("div", {
                    className: "w-full h-[200px] bg-gray-0 rounded-md overflow-scroll custom-scrollbar",
                    children: /*#__PURE__*/ _jsx(Typography, {
                        variant: "body2",
                        className: "text-secondary whitespace-pre-line p-4",
                        children: packageData.description
                    })
                })
            ]
        }),
        openDropDown: dropDown,
        dropDownMode: dropDownMode,
        handleDropDown: ()=>handleDropDown(),
        headRightElement: appliedMaxCoupon && /*#__PURE__*/ _jsx(Tag, {
            size: "md",
            color: "red",
            rating: false,
            children: /*#__PURE__*/ _jsx(Typography, {
                variant: "subtitle2",
                children: "쿠폰 적용중"
            })
        })
    });
};
export default SeparateOrderSection;
